import * as v from 'valibot';

type Translate = (key: string, named: Record<string, unknown>) => string;

/**
 * valibot's default messages, as i18n keys. Messages are functions, so they are
 * resolved at validation time in the active locale. Forms pass no per-call
 * messages for standard validators — add a missing default here instead.
 * (The admin's English-only equivalent is `setupValibotI18n` in libs/core.)
 */
export const setupValibotMessages = (translate: Translate): void => {
  const t = (key: string, named: Record<string, unknown> = {}) => translate(key, named);

  v.setGlobalMessage(() => t('validation.invalid'));
  v.setSchemaMessage(() => t('validation.required'));

  v.setSpecificMessage(v.string, () => t('validation.required'));
  v.setSpecificMessage(v.number, () => t('validation.number'));
  v.setSpecificMessage(v.boolean, () => t('validation.boolean'));
  v.setSpecificMessage(v.date, () => t('validation.date'));
  v.setSpecificMessage(v.picklist, () => t('validation.list'));
  v.setSpecificMessage(v.literal, () => t('validation.invalid'));
  v.setSpecificMessage(v.enum, () => t('validation.invalid'));

  v.setSpecificMessage(v.nonEmpty, () => t('validation.required'));
  v.setSpecificMessage(v.email, () => t('validation.email'));
  v.setSpecificMessage(v.url, () => t('validation.url'));
  v.setSpecificMessage(v.integer, () => t('validation.integer'));
  v.setSpecificMessage(v.regex, () => t('validation.pattern'));
  v.setSpecificMessage(v.isoDate, () => t('validation.date'));
  v.setSpecificMessage(v.isoDateTime, () => t('validation.dateTime'));
  v.setSpecificMessage(v.isoTime, () => t('validation.time'));

  v.setSpecificMessage(v.minLength, (issue) => t('validation.minLength', { requirement: issue.requirement }));
  v.setSpecificMessage(v.maxLength, (issue) => t('validation.maxLength', { requirement: issue.requirement }));
  v.setSpecificMessage(v.length, (issue) => t('validation.length', { requirement: issue.requirement }));
  v.setSpecificMessage(v.minValue, (issue) => t('validation.minValue', { requirement: String(issue.requirement) }));
  v.setSpecificMessage(v.maxValue, (issue) => t('validation.maxValue', { requirement: String(issue.requirement) }));
  v.setSpecificMessage(v.minSize, (issue) => t('validation.minSize', { requirement: issue.requirement }));
  v.setSpecificMessage(v.maxSize, (issue) => t('validation.maxSize', { requirement: issue.requirement }));
};
